import axios from 'axios';

export const TEAM_PRODUCTS_RECEIVED = 'TEAM_PRODUCTS_RECEIVED';


const getTeamProducts = (teamId) => (
  dispatch => (
    axios.get(`/api/teams/${teamId}/products`)
      .then((response) => {
        dispatch({
          type: TEAM_PRODUCTS_RECEIVED,
          all: response.data.data,
        });
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location = '/login';
        }
      })
  )
);

export default getTeamProducts;
